import axios from '@/helpers/axios'

let VueAxiosPlugin = {}

// VueAxiosPlugin.install = (Vue, { router, store }) => { // 应用：Vue.use(VueAxiosPlugin, { router, store })
VueAxiosPlugin.install = Vue => {
  Vue.prototype.$axios = axios
  Vue.prototype.$http = axios
}

export default VueAxiosPlugin
